export const sortFccArticles = (articles, allCategories, allOutlets) => {
  // Create a lookup for category orders
  const categoryOrderLookup = allCategories.reduce((acc, category) => {
    acc[category.name] = category.order
    return acc
  }, {})

  // Function to get the order of a category by its name
  function getCategoryOrder(categoryName) {
    return categoryOrderLookup[categoryName] || 0
  }

  // Function to convert createdAt into a Date object for comparison
  function getCreatedAt(article) {
    return new Date(article.createdAt)
  }

  // Sort articles by category order, then by article order, then by createdAt date
  const sortedArticles = articles.sort((a, b) => {
    const categoryOrderA = getCategoryOrder(a.categoryName)
    const categoryOrderB = getCategoryOrder(b.categoryName)

    if (categoryOrderA !== categoryOrderB) {
      return categoryOrderA - categoryOrderB
    }

    // Use article.order if provided, default to a large number to push articles with no order to the end
    const orderA = a.order !== null ? a.order : 999
    const orderB = b.order !== null ? b.order : 999
    if (orderA !== orderB) {
      return orderA - orderB
    }

    // Finally, sort by createdAt if category and article order are the same
    return getCreatedAt(a) - getCreatedAt(b)
  })

  return sortedArticles
}